import React from 'react'
import PropTypes from 'prop-types'
import { Row } from '../index'

export default function QuickGlanceActions({ children }) {
  return <Row alignX="end">{children}</Row>
}

QuickGlanceActions.propTypes = {
  /** Surround any Buttons in QuickGlanceActions to align them to the end. This component has no props, other than children. */
  children: PropTypes.node,
}
